import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import { useRef } from 'react';
import { useObserveSiteActions } from '../../../hooks/Stations/useObserveSiteActions';
import { Station } from '../../../types/station';
import { CreateObserveSiteDialog } from './CreateObserveSiteDialog';
import { DeleteObserveSiteDialog } from './DeleteObserveSiteDialog';

interface ObserveSiteActionsProps {
  station: Station;
  onChanged: () => void;
  onError: (message: string | null) => void;
  onSyncNotice: (message: string | null) => void;
}

// Every Cobrick Observe action available for a single station, kept out of the stations table so
// the table stays about stations.
export const ObserveSiteActions = ({ station, onChanged, onError, onSyncNotice }: ObserveSiteActionsProps) => {
  const menu = useRef<Menu>(null);

  const {
    hasSite,
    busy,
    usage,
    createVisible,
    deleteVisible,
    openCreate,
    closeCreate,
    createSite,
    downloadConfig,
    openDelete,
    closeDelete,
    confirmDelete,
  } = useObserveSiteActions(station, onChanged, onError, onSyncNotice);

  const menuModel = [
    {
      label: 'Utwórz site',
      icon: 'pi pi-plus-circle',
      disabled: !station.installationId || hasSite,
      command: openCreate,
    },
    {
      label: 'Pobierz konfigurację',
      icon: 'pi pi-download',
      disabled: !hasSite,
      command: downloadConfig,
    },
    {
      label: 'Usuń site',
      icon: 'pi pi-trash',
      disabled: !hasSite,
      command: () => void openDelete(),
    },
  ];

  return (
    <>
      <Button
        icon="pi pi-chart-line"
        className="p-button-rounded p-button-help p-mr-2"
        onClick={(event) => menu.current?.toggle(event)}
        disabled={busy}
        tooltip={'Cobrick Observe'}
        tooltipOptions={{ position: 'bottom' }}
      />
      <Menu popup ref={menu} model={menuModel} />
      <CreateObserveSiteDialog
        visible={createVisible}
        station={station}
        busy={busy}
        onHide={closeCreate}
        onConfirm={() => void createSite()}
      />
      <DeleteObserveSiteDialog
        visible={deleteVisible}
        usage={usage}
        busy={busy}
        onHide={closeDelete}
        onConfirm={() => void confirmDelete()}
      />
    </>
  );
};
